#@import Booking.Presenters.Base
#@export Booking.Presenters.Question

class Booking.Presenters.Question extends Booking.Presenters.Base

  toHash: ->
    question: @model.getQuestion()
    answer: @model.getQuestionsAnswer()
    maxLength: @options.maxLength
    bhc: "input:question"
    bhcNotes: "icon:DeleteNotes"
